
import React, {useEffect, useState, useContext, useRef} from 'react';
import styles from '../../styles/components/ContactForm.module.scss';
import classnames from 'classnames';
import {useForm} from 'react-hook-form';
import {MobileContext} from '../../context/mobileContext';
import useIntersectionObserver from '../../hooks/useIntersectionObserver';
import Select from 'react-select';

export default function ContactFormRoom({data}) {
    const [vorname, setVorname] = useState(null);
    const [nachname, setNachname] = useState(null);
    const [firma, setFirma] = useState(null);
    const [anrede, setAnrede] = useState(null);
    const [titel, setTitel] = useState(null);
    const [email, setEmail] = useState(null);
    const [msg, setMsg] = useState(null);
    const [selectedRooms, setSelectedRooms] = useState([]);
    const [valueVorname, setValueVorname] = useState('');
    const [valueNachname, setValueNachname] = useState('');
    const [valueFirma, setValueFirma] = useState('');
    const [valueAnrede, setValueAnrede] = useState(null);
    const [valueTitel, setValueTitel] = useState('');
    const [valueEmail, setValueEmail] = useState('');
    const [valueMsg, setValueMsg] = useState('');

    const [formSubmitted, setFormSubmitted] = useState(false);

    const randomID = () => {
        return Math.random().toString(16).slice(-4) + "-form";
    }
    const formID = randomID();

    const itemID = (itemName) => {
        return `${formID}-${itemName}`;
    }

    const optionsAnrede = [
        {label: 'Anrede', value: 'Anrede'},
        {label: 'Frau', value: 'Frau'},
        {label: 'Herr', value: 'Herr'},
        {label: 'divers', value: 'divers'},
        {label: 'keine Angabe', value: 'keine Angabe'},
    ];

    const postData = async (url, body) => {
        const requestOptions = {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(body),
        };

        const response = await fetch(url, requestOptions);
        const json = await response.json();

        return json;
    };

    const isMobile = useContext(MobileContext);
    const wrapperRef = useRef(null);
    const onScreen = useIntersectionObserver(wrapperRef);

    const {
        register,
        handleSubmit,
        reset,
        formState: {errors, isSubmitSuccessful},
    } = useForm();

    const onSubmit = (formData) => {
        formData.anrede = valueAnrede;
        formData.location = data.locationTitle;
        formData.raeume = selectedRooms;
        const {email: _, ...tempFormData} = formData;
        const body = {
            style: "secondDefault", //hardcoded for proper mail mapping
            email: formData.email,
            fields: {...tempFormData},
        };

        postData(data.apiURL, body);
    };

    useEffect(() => {
        if (isSubmitSuccessful) {
            reset({
                anrede: null,
                firma: '',
                nachname: '',
                vorname: '',
                titel: '',
                email: '',
                message: '',
            });
            setVorname(null);
            setNachname(null);
            setFirma(null);
            setAnrede(null);
            setTitel(null);
            setEmail(null);
            setMsg(null);
            setSelectedRooms([]);
            setValueVorname('');
            setValueNachname('');
            setValueFirma('');
            setValueAnrede(null);
            setValueTitel('');
            setValueEmail('');
            setValueMsg('');
            setFormSubmitted(true);
        }
    }, [isSubmitSuccessful, reset]);

    const handleVornameChange = (text) => {
        setValueVorname(text);
        setVorname(text !== '');
    };

    const handleNachnameChange = (text) => {
        setValueNachname(text);
        setNachname(text !== '');
    };

    const handleFirmaChange = (text) => {
        setValueFirma(text);
        setFirma(text !== '');
    };

    const handleAnredeChange = (text) => {
        setValueAnrede(text);
        setAnrede(text !== '');
    };

    const handleTitelChange = (text) => {
        setValueTitel(text);
        setTitel(text !== '');
    };

    const handleEmailChange = (text) => {
        setValueEmail(text);
        setEmail(text !== '');
    };

    const handleMessageChange = (text) => {
        setValueMsg(text);
        setMsg(text !== '');
    };

    const handleRoomToggle = (room) => {
        setSelectedRooms((prev) =>
            prev.includes(room)
                ? prev.filter((r) => r !== room)
                : [...prev, room]
        );
    };

    const selectStyles = {
        menu: () => ({
            margin: 0,
            boxShadow: '0px 48px 48px 0px #0E0B350A',
            cursor: 'default',
            position: 'absolute',
            background: '#FFFFFF',
        }),
        menuList: () => ({
            paddingTop: 0,
            paddingBottom: 0,
            zIndex: 50,
            position: 'relative',
            overflow: 'unset',
        }),
        option: (provided, state) => ({
            color: state.isSelected ? '#5eadb7' : '#000000',
            padding: 16,
            background: '#FFFFFF',
            fontFamily: 'DBSans-Regular',
            zIndex: 50,
            position: 'relative',
            border: state.isFocused ? '1px solid black' : 'none',
        }),
        valueContainer: () => ({
            display: 'flex',
            alignItems: 'center',
        }),
        control: () => ({
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            borderRadius: '4px 4px 0 0',
            background: '#282d370d',
        }),
        indicatorSeparator: () => ({
            display: 'none',
        }),
        dropdownIndicator: (provided, state) => ({
            ...provided,
            color: '#5eadb7',
            transition: 'all .3s ease-out',
            transform: state.selectProps.menuIsOpen ? 'rotate(-180deg)' : null,
        }),
        singleValue: () => ({
            margin: '0px',
            padding: '0px',
            color: '#000000',
            fontFamily: 'DBSans-Regular',
            flex: '2 0 100%',
            cursor: 'default',
        }),
    };

    return (
        <div
            className={classnames(
                styles.contactFormWrapper,
                styles.secondDefault,
                onScreen?.isIntersecting ? styles.visible : ''
            )}
            id={data.anchorId}
            ref={wrapperRef}
        >
            <form onSubmit={handleSubmit(onSubmit)}>
                <div
                    className={classnames(
                        styles.formItem,
                        !isMobile ? styles.halfWidth : null
                    )}
                >
                    <div className={styles.staticLocation}>
                        <label>{data.locationTitle}</label>
                    </div>
                </div>
                <div
                    className={classnames(
                        styles.formItem,
                        !isMobile ? styles.halfWidth : null
                    )}
                >
                    <div className={styles.roomCheckboxes}>
                        {data.rooms && data.rooms.length > 0 ? (
                            data.rooms.map((room, index) => (
                                <label key={index} className={styles.selectOptions}>
                                    <input
                                        type="checkbox"
                                        name="rooms"
                                        value={room}
                                        checked={selectedRooms.includes(room)}
                                        onChange={() => handleRoomToggle(room)}
                                    />
                                    {room}
                                </label>
                            ))
                        ) : (
                            <div className={styles.checkboxPlaceholder}>Keine Räume verfügbar</div>
                        )}
                    </div>
                </div>
                <div
                    className={classnames(
                        styles.formItem,
                        !isMobile ? styles.halfWidth : null
                    )}
                >
                    <Select
                        aria-label="anrede dropdown"
                        classNamePrefix="select"
                        options={optionsAnrede}
                        styles={selectStyles}
                        isSearchable={false}
                        onChange={(e) => handleAnredeChange(e.value)}
                        value={
                            anrede
                                ? {label: valueAnrede, value: valueAnrede}
                                : optionsAnrede[0]
                        }
                        className={styles.selectStyle}
                    />
                    {errors.anrede && (
                        <span className={styles.error}>This field is required</span>
                    )}
                </div>
                <div
                    className={classnames(
                        styles.formItem,
                        !isMobile ? styles.halfWidth : null
                    )}
                >
                    <input
                        id={itemID("titel")}
                        type="text"
                        name="titel"
                        {...register('titel', {})}
                        onChange={(e) => handleTitelChange(e.target.value)}
                    />
                    <label
                        htmlFor={itemID("titel")}
                        className={classnames(
                            styles.namePlaceholder,
                            titel ? styles.namePlaceholderAct : null
                        )}
                    >
                        Titel
                    </label>
                </div>
                <div
                    className={classnames(
                        styles.formItem,
                        !isMobile ? styles.halfWidth : null
                    )}
                >
                    <input
                        id={itemID("vorname")}
                        type="text"
                        name="vorname"
                        {...register('vorname', {required: true})}
                        onChange={(e) => handleVornameChange(e.target.value)}
                        required
                    />
                    <label
                        htmlFor={itemID("vorname")}
                        className={classnames(
                            styles.namePlaceholder,
                            vorname ? styles.namePlaceholderAct : null
                        )}
                    >
                        Vorname*
                    </label>
                    {errors.vorname && (
                        <span className={styles.error}>This field is required</span>
                    )}
                </div>
                <div
                    className={classnames(
                        styles.formItem,
                        !isMobile ? styles.halfWidth : null
                    )}
                >
                    <input
                        id={itemID("nachname")}
                        type="text"
                        name="nachname"
                        {...register('nachname', {required: true})}
                        onChange={(e) => handleNachnameChange(e.target.value)}
                        required
                    />
                    <label
                        htmlFor={itemID("nachname")}
                        className={classnames(
                            styles.namePlaceholder,
                            nachname ? styles.namePlaceholderAct : null
                        )}
                    >
                        Nachname*
                    </label>
                    {errors.nachname && (
                        <span className={styles.error}>This field is required</span>
                    )}
                </div>
                <div
                    className={classnames(
                        styles.formItem,
                        !isMobile ? styles.halfWidth : null
                    )}
                >
                    <input
                        id={itemID("firma")}
                        type="text"
                        name="firma"
                        {...register('firma', {})}
                        onChange={(e) => handleFirmaChange(e.target.value)}
                    />
                    <label
                        htmlFor={itemID("firma")}
                        className={classnames(
                            styles.namePlaceholder,
                            firma ? styles.namePlaceholderAct : null
                        )}
                    >
                        Firma
                    </label>
                </div>
                <div
                    className={classnames(
                        styles.formItem,
                        !isMobile ? styles.halfWidth : null
                    )}
                >
                    <input
                        id={itemID("email")}
                        type="email"
                        name="email"
                        {...register('email', {
                            required: 'This field is required',
                            pattern: {
                                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                message: 'Invalid email address',
                            },
                        })}
                        onChange={(e) => handleEmailChange(e.target.value)}
                        required
                    />
                    <label
                        htmlFor={itemID("email")}
                        className={classnames(
                            styles.emailPlaceholder,
                            email ? styles.emailPlaceholderAct : null
                        )}
                    >
                        E-Mail*
                    </label>
                    {errors.email && (
                        <span className={styles.error}>{errors.email?.message}</span>
                    )}
                </div>
                <div className={styles.formItem}>
                    <textarea
                        id={itemID("message")}
                        name="message"
                        {...register('message', {required: true})}
                        onChange={(e) => handleMessageChange(e.target.value)}
                        required
                    />
                    <label
                        htmlFor={itemID("message")}
                        className={classnames(
                            styles.msgPlaceholder,
                            msg ? styles.msgPlaceholderAct : null
                        )}
                    >
                        Meine Frage...*
                    </label>
                    {errors.message && (
                        <span className={styles.error}>This field is required</span>
                    )}
                </div>
                <button
                    className={classnames(styles.button, styles.primary)}
                    type="submit"
                    disabled={formSubmitted}
                >
                    {formSubmitted ? 'Nachricht erfolgreich versendet' : data.ctaText}
                </button>
                <div className={styles.formItem} style={{textAlign: 'right'}}>
                    <span>*Pflichtfeld</span>
                </div>
            </form>
        </div>
    );
}